import type {
  KnowledgeCreateInput,
  KnowledgeDocument,
  KnowledgeUpdateInput,
} from "@chat-yai/shared/admin-types";
import type { PaginatedResponse } from "@chat-yai/shared";
import { request } from "@/api/client";

export const knowledgeApi = {
  list(query: {
    chatbot_id: string;
    q?: string;
    page?: number;
    page_size?: number;
  }) {
    return request<PaginatedResponse<KnowledgeDocument>>("/admin/knowledge", {
      query,
    });
  },
  create(input: KnowledgeCreateInput) {
    return request<{ doc: KnowledgeDocument }>("/admin/knowledge", {
      method: "POST",
      body: input,
    });
  },
  update(id: string, input: KnowledgeUpdateInput) {
    return request<{ doc: KnowledgeDocument }>(`/admin/knowledge/${id}`, {
      method: "PATCH",
      body: input,
    });
  },
  remove(id: string) {
    return request<{ ok: true }>(`/admin/knowledge/${id}`, { method: "DELETE" });
  },
};
